import { render } from "./participation-form.vue?vue&type=template&id=4659aefb"
import script from "./participation-form.vue?vue&type=script&lang=js"
export * from "./participation-form.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thanyakornphanthamit/Desktop/vue/wedday/guest-registation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__